import angular from "angular";

angular
    .module('app')
    .component('courseTraining', {
        template: require('./course-training.html'),
        controller: ['Upload', '$uibModal', '$http', '$sce', '$timeout', '$interval', 'Notifier', 'trans', 'Language', '$rootScope', controller],
        bindings: {
            userCourseId: '<',
            course: '<',
            courseStatus: '@',
            lesson: '<',
            answer: '<',
            lessonComments: '<',
            commentId: '@',
            existsReview: '@',
            nextLessonId: '@',
            quizResult: '<',
        }
    });

function controller(Upload, $uibModal, $http, $sce, $timeout, $interval, Notifier, trans, Language, $rootScope) {

    let $ctrl = this;

    $ctrl.l = null;

    $ctrl.questions = null;

    $ctrl.quizId = null;


    $ctrl.$onInit = function () {
        $ctrl.language = Language;

        $timeout(() => {
            Array.from(document.querySelectorAll('.js-player')).map(p => new Plyr(p));
        }, 500);

        $timeout(function () {
            $ctrl.lessons = [];
            $ctrl.course.chapters.forEach(function (chapter, chapterInd) {
                chapter.lessons.forEach(function (lesson, lessonInd) {
                    $ctrl.lessons.push(lesson);
                    lesson.pTitle = (chapterInd + 1) + '.' + (lessonInd + 1) + ' ' + lesson.title;
                    if (lesson.id === $ctrl.lesson.id) {
                        chapter.open = true;
                    }
                });
            });
        });

        setVimeoVideos();

        $ctrl.lessonStatus = $ctrl.lesson.status;
        $ctrl.lessonCanOpen = $ctrl.lesson.can_open;
        $ctrl.lessonIsNew = $ctrl.lesson.is_new;

        // console.log($ctrl.lesson);
        // console.log($ctrl.course);
    };

    $ctrl.completeLesson = function (lessonId) {
        $http.post(`/cabinet/courses/${$ctrl.course.id}/complete/lessons/${lessonId}`).then(
            function (response) {
                if (response.data.have_to_finish_homework || response.data.have_to_finish_quiz) {
                    $ctrl.lesson.status = 'current';

                    $ctrl.course.chapters.forEach(function (chapter, chapterInd) {
                        chapter.lessons.forEach(function (lesson, lessonInd) {
                            if (lesson.id == lessonId) {
                                lesson.status = 'current';
                            }
                        });
                    });

                    window.Swal.fire({
                        icon: 'warning',
                        title: trans("Finish homework or quiz successfully, before completing lesson"),
                        showConfirmButton: true,
                    });

                } else {
                    let nextLessonId = response.data.next_lesson_id;

                    $ctrl.lesson.status = 'completed';
                    $ctrl.course.chapters.forEach(function (chapter, chapterInd) {
                        chapter.lessons.forEach(function (lesson, lessonInd) {
                            if (lesson.id == lessonId) {
                                lesson.status = 'completed';
                            }
                        });
                    });
                    if (nextLessonId) {
                        let link = `/cabinet/courses/${$ctrl.course.id}/?lesson_id=${nextLessonId}`;

                        window.Swal.fire({
                            icon: 'success',
                            title: trans("Lesson completed successfully"),
                            showConfirmButton: false,
                            html: '<a href="' + link + '" class="btn btn-primary mb-3 mt-3"> ' + trans("Go to the next lesson") + '</a>\n'
                        });

                    } else {
                        if (response.data.course_completed) {
                            $ctrl.courseStatus = 'completed';
                            let link = `/cabinet/courses/${$ctrl.course.id}/review`;

                            let html;

                            if ($ctrl.language == 'kk') {
                                html = 'Курс аяқталды.' + '<br>' + 'Курс бойынша пікір қалдыруды өтінеміз' + '<br>' + '<a href="' + link + '" class="mb-3 mt-3"> ' + 'Пікір қалдыруға өту' + '</a>\n';
                            }

                            if ($ctrl.language == 'ru') {
                                html = 'Курс пройден.' + '<br>' + 'Просим оставить отзыв.' + '<br>' + '<a href="' + link + '" class="mb-3 mt-3"> ' + 'Перейти к форме отзыва' + '</a>\n'
                            }

                            window.Swal.fire({
                                icon: 'success',
                                title: trans('Congratulate'),
                                showConfirmButton: false,
                                html
                            });
                        } else {

                            window.Swal.fire({
                                icon: 'success',
                                title: trans('Lesson completed successfully'),
                            });
                        }
                    }
                }
            },
            function (error) {
                Notifier.error(error.data.message, 2);
            }
        )
    };

    function setOpenChapter() {
        $timeout(function () {

            let hasOpened = false;

            $ctrl.course.chapters.forEach(function (chapter) {
                chapter.open = false;
                if ($ctrl.lesson && $ctrl.lesson.chapter_id === chapter.id) {
                    chapter.open = true;
                    hasOpened = true;
                }
            });

            if (!hasOpened && $ctrl.course.chapters && $ctrl.course.chapters[0]) {
                $ctrl.course.chapters[0].open = true;
            }

        });
    }

    function setVimeoVideos() {
        if ($ctrl.lesson && $ctrl.lesson.data) {
            $timeout(function () {
                $ctrl.lesson.data.forEach(function (item) {
                    if (item.type === 'youtube') {
                        item.src  = $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + item.code + '?origin=https://plyr.io&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1');
                        item.trustedHtml = $sce.trustAsHtml(item.html);
                    }
                });
            });
        }
    }

    function runSessionCheck() {
        $interval(function () {
            $http
                .get('/session-check')
                .then(
                    function (response) {
                        if (!response.data.result) {
                            window.location = '/';
                        }
                    },
                    function (error) {
                        if (error.status == 401) {
                            window.location = '/';
                        }
                    }
                );
        }, 1000 * 60);
    }

    $ctrl.toggleChapter = function (chapter) {
        chapter.open = !chapter.open;
    };

    $ctrl.openChaptersModal = function () {
        $uibModal
            .open({
                component: 'courseChaptersModal',
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    },
                    lesson: function () {
                        return $ctrl.lesson;
                    }
                },
                size: 'sm',
                windowClass: 'chapters-modal',
            })
            .result
            .then(
                function (result) {
                },
                function (error) {

                }
            );
    };

    $ctrl.goToLesson = function () {
        if ($ctrl.l) {
            window.location = `/cabinet/courses/${$ctrl.course.id}/?lesson_id=${$ctrl.l.id}`;
        }
    };

    $ctrl.startQuiz = function () {
        let url = `/cabinet/courses/${$ctrl.course.id}/lesson/${$ctrl.lesson.id}/quiz`;
        $http.get(url).then(
            function (response) {
                $ctrl.questions = response.data;
                $ctrl.quizId = $ctrl.questions[0].quiz_id;
            }
        )
    }
    $rootScope.$on('quizFinished', (event, data) => {
        $ctrl.questions = null;
        $ctrl.quizResult = data.quizResult;
    });
}
